import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import Logo1 from "../../Assets/Picture1.png";
import Logo2 from "../../Assets/Picture2.png";
import Logo3 from "../../Assets/NewImages/New_Logo.jpg";
// import Logo4 from "../../Assets/logo4.png";

const HeroSection = () => {
  return (
    <section
      style={{
        backgroundImage: `url(${require("../../Assets/conffBg.jpg")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        position: "relative",
        color: "#fff",
      }}
      className="d-flex align-items-center justify-content-center text-center px-3 py-5"
    >
      {/* Dark overlay */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{ backgroundColor: "rgba(0, 0, 0, 65%)", zIndex: 1 }}
      ></div>

      <Container
        style={{
          zIndex: 2,
          borderRadius: "20px",
          padding: "2rem",
          marginTop: "2.5rem",
        }}
      >
        {/* Responsive inner content container - UPDATED WIDTH */}
        <div
          style={{
            zIndex: 2,
            backdropFilter: "blur(8px)",
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            borderRadius: "20px",
            padding: "0.5rem 1rem 0.5rem 1rem",
            boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
            marginBottom: "1rem",
            marginTop: "1rem",
            width: "70%", // Changed from display: "inline-block" to full width
            maxWidth: "70%",
          }}
          className="mx-auto"
        >
          {/* Logos */}
          <Row className="justify-content-center mb-4 gx-3">
            <div className="notification-banner">
              <marquee behavior="scroll" direction="left" scrollamount="6">
                <strong>
                  Thank you all for the overwhelming response to TNPY AMPICON
                  2025!
                </strong>
              </marquee>
            </div>

            <Col xs={6} sm={4} className="">
              <Image
                src={Logo3}
                fluid
                style={{ maxHeight: "120px", marginTop: "30px" }}
              />
            </Col>
            <Col xs={6} sm={4} className="">
              <Image src={Logo1} fluid style={{ maxHeight: "120px" }} />
            </Col>
            <Col xs={6} sm={4} className="">
              <Image src={Logo2} fluid style={{ maxHeight: "120px" }} />
            </Col>

            <div className="notification-banner">
              <marquee behavior="scroll" direction="left" scrollamount="6">
                The Conference on the Future of Medical Physics in Oncology was
                successfully held in Chennai.
                <strong>
                  {" "}
                  We extend our heartfelt thanks to all attendees and
                  contributors.
                </strong>
              </marquee>
            </div>
          </Row>
        </div>

        <Row className="justify-content-center">
          <Col lg={10}>
            <div className="mb-3">
              <span
                className="px-4 py-2 rounded-pill fw-bold d-inline-block mb-2"
                style={{
                  backgroundColor: "#2ecc71",
                  fontSize: "0.95rem",
                  letterSpacing: "0.05em",
                }}
              >
                Organized by: Apollo Cancer Centres, Chennai
              </span>
            </div>

            <div className="fw-bold mb-3 d-flex justify-content-center">
              <p
                className="d-flex fs-2 fs-md-1"
                style={{
                  backgroundColor: "rgb(56, 11, 109)",
                  padding: "0.2rem 1rem",
                  borderRadius: "15px",
                  color: "white",
                }}
              >
                TNPY AMPICON 2025
              </p>
              {/* <span className="d-block text-danger fs-3 fs-md-1"></span> */}
            </div>

            <h4 className="fw-semibold mb-3 text-white d-flex flex-column align-items-center">
              <span className="fs-8 fs-md-5 lh-2">
                28<sup>th</sup> Annual Conference
              </span>
              <span className="fs-8 fs-md-4 text-center lh-2">
                Association of Medical Physicist of India
              </span>
              <span className="fs-8 fs-md-5 lh-2">
                (Tamil Nadu and Puducherry Chapter)
              </span>
            </h4>

            <h5 className="fw-normal mb-4 text-white fs-6 fs-md-5">
              <strong>
                26<sup>th</sup> - 27<sup>th</sup> September
              </strong>{" "}
              Vaanagaram, Chennai, TN.
            </h5>

            <span
              className="px-4 py-2 rounded-pill d-inline-block mb-2"
              style={{
                backgroundColor: "rgb(255, 45, 84)",
                color: "white",
                fontWeight: "600",
                fontSize: "1rem",
              }}
            >
              Theme: "Solving New Challenges in Personalised Oncology:
              Automation and Accuracy in Medical Physics"
            </span>

            <p className="mt-4 mb-0 text-light fw-light fst-italic fs-6 fs-md-5">
              Venue: College Auditorium, Apollo Cancer Centre - Vanagaram,
              Chennai.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
